import React from 'react';
import Button from '@ids/button';
import PropTypes from 'prop-types';
import '../../../stylesheets/checkAndSuppliesResourceCenter.scss';
import '../../../stylesheets/main.scss';
import ArticleCard from './ArticleCard';
import ResourceCenterFooter from '../Common/ResourceCenterFooter';
import { getImageSrc } from '../Util/CommonUtils';

const ResourceCenterArticleList = ({ pageData }) => {
  return (
    <>
      <div className="container-center-lg template ">
        <div
          className={`container paddingOutside ${
            pageData.DetailsbottomPadding ? pageData.DetailsbottomPadding : ''
          }`}
        >
          <a href="/resources">
            <Button className="back-to-center">Back to Resource Center</Button>
          </a>
          <h1>{pageData.title}</h1>
          <p className="subHeader">{pageData.subTitle}</p>
          {pageData.details && (
            <div className="row ResourceCenterDetails">
              <div className="col-lg-6">
                {pageData.details.map((data) => {
                  return <ArticleCard data={data} isSmall={pageData.isSmallCard} />;
                })}
              </div>
              <div className="col-lg-6">
                <img src={getImageSrc(pageData.image)} alt="HeroImage" />
              </div>
            </div>
          )}
        </div>
      </div>
      {pageData.faq && (
        <div className={`faq ${pageData.details ? 'faq-background-color' : ''}`}>
          <div className="container-center-lg">
            <div className="row text-align-center paddingOutsideFaq">
              {pageData.faq.map((data) => {
                return (
                  <div className="col-lg-4">
                    <ArticleCard data={data} isSmall />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
      <ResourceCenterFooter />
    </>
  );
};
ResourceCenterArticleList.propTypes = {
  pageData: PropTypes.objectOf(Object),
};
export default ResourceCenterArticleList;
